import {IssueTemplateItem} from './IssueTemplateItem'
import type {IssueFormNode} from './template-list-query-types'
import {IssueCreationKind} from './utils/model'
import {getTemplateUrl} from './utils/urls'

export type IssueFormRowFragment = Pick<IssueFormNode, 'name' | 'description' | 'filename'>

type IssueFormRowProps = {
  onTemplateSelected?: (filename: string, kind: IssueCreationKind) => void
  form: IssueFormRowFragment
  nameWithOwner: string
}

export const IssueFormRow = ({nameWithOwner, form, onTemplateSelected}: IssueFormRowProps) => {
  return (
    <IssueTemplateItem
      filename={form.filename}
      onTemplateSelected={filename => onTemplateSelected?.(filename, IssueCreationKind.IssueForm)}
      name={form.name}
      about={form.description}
      link={onTemplateSelected ? undefined : getTemplateUrl(nameWithOwner, form.filename)}
    />
  )
}
